<template>
    <div class="headContainer">
        <div class="menuList">
            <div class="menuTop flexRow">
                <div class="menuBtn" @click="showMenu">
                    <img src="./../../assets/list.png"/>
                    <span>栏目</span>
                </div>
                <div class="AllTitle">
                    {{title}}
                </div>
                <div class="menuBack">
                    <!--返回-->
                    <!--<img src="./../../assets/left.png"/>-->
                </div>
            </div>
            <div class="menuBottom"
                 :style="{ left: showList ? '0':'-55%'}">
                <div class="menu">
                    <div class="menuTitle" @click="goIndex">首页</div>
                </div>
                <div class="menu" v-for="item in menuList" :key="'t' + item.id">
                    <div class="menuTitle flexRow"
                         @click="openDrop(item.id)"
                         :key="'h' + item.id">
                        <div>{{item.title}}</div>&nbsp;&nbsp;
                        <div class="order">+</div>
                    </div>
                    <div class="menuChild" v-if="item.expand" :key="'f' + item.id">
                        <ul>
                            <li v-for="child in item.children" :key="child.id" @click="openAllList(child.title,child.id)">
                                {{child.title}}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="menu">
                    <div class="menuTitle" @click="goFeedback">委员反馈</div>
                </div>
                <div class="menu">
                    <div class="menuTitle" @click="goMistake">网站纠错</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "phoneHead2",
        props: {
            menuList: {
                type: Array,
                required: true
            },
            title: {
                type: String
            }
        },
        data () {
            return {
                showList:false,
                drop: false,
                key: ''
            }
        },
        methods: {
            showMenu () {
                this.showList = !this.showList
            },
            openDrop (id) {
                this.$emit('doDrop', id)
            },
            goIndex () {
                this.$router.push({
                    path:'/home'
                });
            },
            goFeedback () {
                this.$router.push({
                    path: '/more/feedback'
                })
            },
            goMistake () {
                this.$router.push({
                    path: '/more/mistake'
                })
            },
            goBack () {
                // location.href=document.referrer
                window.history.go(-1)
            },
            openAllList (title, id) {
               if(id == '8707426274508819'){//基金捐赠
                    window.open("http://wx.sxcs.n.gongyibao.cn/#/funddetail?id=744f8520-a780-4fc0-a15c-e8dff4f3b4a9") 
                    return
                }
                // 专家介绍
                if (id == '23'){
                    this.$router.push({
                        path:'/more/doc',
                        query: { type: 'commit' }
                    });
                    return
                }
                // 会议视频
                if (id == '366733301051119603') {
                    this.$router.push({
                        path:'/more/doc',
                        query: { type: 'video', video: '会议视频' }
                    });
                    return
                }
                // 讲座视频
                if (id == '31') {
                    this.$router.push({
                        path:'/more/doc',
                        query: { type: 'video', video: '公益讲座'  }
                    });
                    return
                }
                this.$router.push({
                    path:'/news/alllist',
                    query: { id: id, title: title }
                });
                this.showList = false
            },
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
    @baseBase: #eaf0eb;
    @base: #3e8f83;
    .headContainer{
        width:100%;
        height: auto;
    }
    .menuList{
        width: 100%;
        height: auto;
        background-color: @base;
        position: fixed;
        top:0;
        left:0;
        width:100%;
        z-index: 99;
        .menuTop{
            width: 92%;
            height: 0.9rem;
            line-height: 0.5rem;
            padding:0.2rem 0 0.2rem 0.5rem;
            margin:0 auto;
            box-sizing: border-box;
            /*border-bottom: 0.01rem solid #fff;*/
            justify-content: space-between;
            .menuBack {
                width: 0.5rem;
                height: 0.5rem;
                font-size: 8px;
                color: #fff;
                position: relative;
                img{
                    width: 0.3rem;
                    height: 0.3rem;
                    padding-top: 0.1rem;
                    box-sizing: content-box;
                    vertical-align: top;
                }
            }
            .menuBtn{
                position: absolute;
                top: 0.1rem;
                left: 0.26rem;
                width: 0.5rem;
                height: 0.7rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                background-color: transparent;
                img{
                    width: 0.36rem;
                    height: 0.36rem;
                    padding-top: 0.1rem;
                    /*padding-left: 0.08rem;*/
                    box-sizing: content-box;
                    vertical-align: top;
                }
                span {
                    font-size: 12px;
                    color: #fff;
                    line-height: 16px;
                }
            }
            .AllTitle{
                width: 100%;
                height: 100%;
                text-align: center;
                color:#fff;
                font-size:15px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .collapse {
            width: 100%;
            height: auto;
            transition:height 0.35s ease;
        }
        .menuBottom{
            width: 50%;
            height: 100%;
            position: fixed;
            top:0.9rem;
            background-color: #fff;
            transition: left 0.5s linear;
            overflow-y: scroll;
            box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
            .menu{
                width:100%;
                height: auto;
                display:block;
                border-bottom:1px solid #e5e5e5;
            }
            .menuTitle{
                color:#000;
                width:92%;
                padding:0 4%;
                height: 0.65rem;
                line-height: 0.65rem;
                text-indent: 0.2rem;
                font-size: 12px;
                box-sizing: content-box;
                justify-content: space-between;
            }
            .menuChild{
                color:#000;
                font-size:10px;
                background-color: #f9f9f9;
                ul{
                    margin-bottom: 0;
                }
                li{
                    width:92%;
                    padding:0 4%;
                    height: 0.5rem;
                    line-height: 0.5rem;
                    text-indent: 0.3rem;
                    border-bottom: 1px solid #efefef;
                    box-sizing: content-box;
                }
            }
            /*.menu:active{
              .menuChild{
                display: block;
              }
            }*/
            .order{
                font-size: 15px;
                /*width: 0px;*/
                /*height: 0px;*/
                /*display: inline-block;*/
                /*border-width: 3px;*/
                /*border-style: solid;*/
                /*border-color: #ffffff transparent transparent;*/
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/phone/phoneHead2.vue